import React, {Component} from 'react';
import { connect } from 'react-redux';
import Header from '../base/header';
import Title from '../base/title';
import Dropdown from '../base/dropdown';
import MarketShare from './marketshare';
import MarketShareCluster from './marketsharecluster';
import Strategy from './strategy';
import Pumps from './pumps';
import Prices from './prices';
import PricesPump from './pricespump';
import EditableStrategy from './editablestrategy';
import EditableStrategyPump from './editablestrategypump';
import Sensibility from './sensibility';
import Desvios from './desvios';
import Edit from './edit';
import CloseStations from './closestations';
import Station from './station';
import PricesStation from './pricesstation';
import api from '../../utils/api';


class Analisis extends Component {

    constructor(props) {
      super(props);
      this.state = {
        /** combos **/
        search: [{ id: '', label: "SELECCIONAR" },{ id: 'CLUSTER', label: "CLUSTER" },{ id: 'PROVINCE', label: "PROVINCIA" },{ id: 'COUNTRY', label: "PAIS" }],
        cluster: [{ id: 0, label: "SELECCIONAR" }],
        boca: [{ id: 0, label: "SELECCIONAR" }],
        /** dummy data **/
        searchValue: { id: 'COUNTRY', label: "PAIS" },
        clusterValue: { id: 0, label: "SELECCIONAR" },
        clusterData: {},
        bocaValue: {},
        station: {},
        /** page title */
        title: 'Cargando...',
        titleClass: '',
        breadcrumbText: '',
        /** page state **/
        isLoading: true,
        isCountry: false,
        isCluster: false,
        isEdit: false,
        isBoca: false,
        isStation: false,
        readOnly: false
      };

      this.getSearchItem = this.getSearchItem.bind(this);
      this.getClusterItem = this.getClusterItem.bind(this);
      this.getBocaItem = this.getBocaItem.bind(this);
      this.cancelEditCluster = this.cancelEditCluster.bind(this);
      this.saveEditCluster = this.saveEditCluster.bind(this);
      this.goToStation = this.goToStation.bind(this);
      
      this.showEditCluster = this.showEditCluster.bind(this);
      this.setSectionActive = this.setSectionActive.bind(this);
      this.setCountryActive = this.setCountryActive.bind(this);
      this.setClusterActive = this.setClusterActive.bind(this);
      this.setBocaActive = this.setBocaActive.bind(this);
      this.setEditActive = this.setEditActive.bind(this);
      this.setStationActive = this.setStationActive.bind(this);
      this.autocompleteStation = this.autocompleteStation.bind(this);
      this.loadStation = this.loadStation.bind(this);
      this.goBack = this.goBack.bind(this);
    }

    componentWillMount() {
      let _self = this;
      let { type, action, id } = this.props.match.params;
      //let state = {};

      if (type === 'cluster') {
        api.get('clusters').then(clusters => {
          let _clusters = [];
          clusters.data.forEach(cl => {
            _clusters.push({
              id: cl.id, label: cl.name, icon: cl.is_core ? 'star' : ''
            })
          });
          _self.setState({
            cluster: _clusters,
            searchValue: { id: 'CLUSTER', label: "CLUSTER" }
          }, function() {
            if (action && action === 'editar') {
              _self.showEditCluster(id);
            } else if (type === 'cluster' && id === 'nuevo') {
              _self.showEditCluster();
            } else {
              _self.getClusterItem({ id: id });
            }
          });
        });
      } else if (type === 'provincia') {
        api.get('provinces').then(clusters => {
          let _clusters = [];
          clusters.data.forEach(cl => {
            _clusters.push({
              id: cl.id, label: cl.name
            })
          });
          _self.setState({
            cluster: _clusters,
            searchValue: { id: 'PROVINCE', label: "PROVINCIA" }
          }, function() {
            _self.getClusterItem({ id: id });
          });
        });
      } else if (type === 'estacion') {
        this.loadStation();
      } else {
        this.setCountryActive();
      }
    }

    loadStation() {
      let _self = this;
      let { id } = this.props.match.params;
      api.get('stations/id/' + id).then(resp => {
        let station = resp.data;
        let key = 'OTRAS';
        if (station.brand.name.indexOf('SHELL') >= 0) key = 'SHELL';
        else if (station.brand.name.indexOf('YPF') >= 0) key = 'YPF';
        else if (station.brand.name.indexOf('AXION') >= 0) key = 'AXION';
        else if (station.brand.name.indexOf('PETROBRAS') >= 0) key = 'PETROBRAS';

        this.setState({
          searchValue: { id: 'CLUSTER', label: "CLUSTER" },
          clusterValue: resp.data.pricing_cluster ? { id: resp.data.pricing_cluster.id, label: resp.data.pricing_cluster.name } : { id: 0, label: "SELECCIONAR" },
          bocaValue: station,
          station: station,
          breadcrumbText: key === 'SHELL' ? ('Shell ' + (station.global_code ? station.global_code : "")) : 'Vista estación',
          title: key === 'SHELL' ? ('Shell ' + (station.global_code ? station.global_code : "")) : key,
          titleClass: key.toLowerCase()
        }, function() {
          _self.refs.dcountry.update({ id: 'CLUSTER', label: "CLUSTER" });
          if (key === 'SHELL') _self.setBocaActive();
          else _self.setStationActive();
        });
      });
    }

    cancelEditCluster(sharedState) {
      this.getClusterItem(this.state.clusterValue);
    }

    saveEditCluster(sharedState) {
      
    }

    goBack() {
      window.history.back();
      setTimeout(function() {
        window.location.reload();
      }, 100);
    }

    getSearchItem(item) {
      let _self = this;
      let newState = { 
        searchValue: item,
        cluster: [],
        boca: [],
        isLoading: true,
        isCountry: false,
        isCluster: false,
        isBoca: false,
        isEdit: false,
        isStation: false,
        readOnly: false
      };
      if (item.id === 'CLUSTER') {
        api.get('clusters').then(clusters => {
          let _clusters = [];
          _clusters.push({ id: 0, label: "SELECCIONAR" });
          clusters.data.forEach(cl => {
            _clusters.push({
              id: cl.id, label: cl.name, icon: cl.is_core ? 'star' : ''
            })
          });
          newState.cluster = _clusters;
          _self.setState(newState, function() {
            _self.refs.dcountry.update(_self.state.searchValue);
            _self.refs.dcluster.update(_clusters[1]);
            _self.refs.dpump.update(_self.state.bocaValue, true);
            _self.getClusterItem(_clusters[1]);
          });
        });
      } else if (item.id === 'PROVINCE') {
        api.get('provinces').then(provinces => {
          let _clusters = [];
          _clusters.push({ id: 0, label: "SELECCIONAR" });
          provinces.data.forEach(province => {
            _clusters.push({
              id: province.id, label: province.name
            })
          });
          newState.cluster = _clusters;
          _self.setState(newState, function() {
            _self.refs.dcountry.update(_self.state.searchValue);
            _self.refs.dcluster.update(_clusters[1]);
            _self.refs.dpump.update(_self.state.bocaValue, true);
            _self.getClusterItem(_clusters[1]);
          });
        });
      } else if (item.id === 'COUNTRY') {
        window.history.pushState('country', 'ARGENTINA', '/analisis/');
        newState.readOnly = false;
        newState.isLoading = false;
        newState.isCountry = true;
        newState.searchValue = item;
        newState.titleClass = '';
        newState.title = 'ARGENTINA';
        newState.cluster = [{ id: 0, label: "SELECCIONAR" }];
        newState.boca = [{ id: 0, label: "SELECCIONAR" }];
        newState.searchValue = { id: 'COUNTRY', label: "PAIS" };
        newState.clusterValue = { id: 0, label: "SELECCIONAR" };
        newState.clusterData = {};
        newState.bocaValue = { id: 0, label: "SELECCIONAR" };
        _self.setState(newState, function() {
          _self.refs.dcountry.update(_self.state.searchValue);
          _self.refs.dcluster.update(_self.state.clusterValue);
          _self.refs.dpump.update(_self.state.bocaValue, true);
        });
      }
    }

    autocompleteStation(search) {
      if (!search) return;

      let _self = this;
      let level = 'type=' + this.state.searchValue.id;
      if (this.state.searchValue.id !== 'COUNTRY') {
        level += '&id=' + this.state.clusterValue.id;
      }

      api.get('stations/search/?' + level + '&search=' + search, true).then(station => {
        let _stations = [{ id: 0, label: "SELECCIONAR" }];
        station.data.forEach(station => {
          _stations.push({
            id: station.id, label: station.full_address, color: 'shell'
          })
        });
        _self.setState({
          boca: _stations
        }, function() {
          _self.refs.dpump.show();
        });
      })
    }

    showEditCluster(id) {
      let _self = this;
      if (id) {
        api.get('clusters/id/' + id).then(resp => {
          window.history.pushState('cluster', 'ARGENTINA > ' + resp.data.name, '/analisis/cluster/editar/' + resp.data.id);
          _self.setState({ 
            clusterValue: { id: resp.data.id, label: resp.data.name },
            clusterData: resp.data,
            boca: [{ id: 0, label: "SELECCIONAR" }, { id: 0, label: "" }],
            title: 'ARGENTINA > ' + resp.data.name,
            isLoading: false,
            isCountry: false,
            isCluster: false,
            isBoca: false,
            isEdit: true,
            isStation: false,
            breadcrumbText: 'Editar Cluster'
          });
        });
      } else {
        _self.setState({ 
          title: 'ARGENTINA > Nuevo Cluster',
          isLoading: false,
          isCountry: false,
          isCluster: false,
          isBoca: false,
          isEdit: true,
          isStation: false,
          breadcrumbText: 'Nuevo Cluster'
        });
      }
    }

    getClusterItem(item) {
      let _self = this;
      this.setState({
        isLoading: true,
        isCluster: false,
        title: 'Cargando...',
      }, function() {
        api.get((this.state.searchValue.label === 'CLUSTER' ? 'clusters' : 'provinces') + '/id/' + item.id).then(data => {
          window.history.pushState('cluster', 'ARGENTINA > ' + data.data.name, '/analisis/' + (_self.state.searchValue.label === 'CLUSTER' ? 'cluster' : 'provincia') + '/' + item.id);
          _self.setState({ 
            clusterValue: { id: item.id, label: data.data.name },
            searchValue: this.state.searchValue,
            clusterData: data.data,
            boca: [{ id: 0, label: "SELECCIONAR" }, { id: 0, label: "" }],
            title: 'ARGENTINA > ' + data.data.name,
            titleClass: '',
            isLoading: false,
            isCountry: false,
            isCluster: true,
            isBoca: false,
            isEdit: false,
            isStation: false
          }, function() {
            _self.refs.dcountry.update(_self.state.searchValue);
            _self.refs.dcluster.update({ id: item.id, label: data.data.name });
            _self.refs.pumps.updateView();
          });
        })
      })
    }

    getBocaItem(station) {
      let _self = this;
      api.get('stations/id/' + station.id).then(resp => {
        station = resp.data;
        let isShell = station.brand.name.toLowerCase().indexOf('shell') >= 0;
        window.history.pushState('cluster', 'ARGENTINA > ' + (isShell ? ('Shell ' + station.global_code) : station.inscription_number), '/analisis/estacion/' + station.id);
        let shell_title = ('Shell - Global code: ' + station.global_code + " (NI: " + station.inscription_number + ")");
        let competitor_title = station.brand.name + " " + station.inscription_number;
        _self.setState({
          bocaValue: station,
          breadcrumbText: isShell ? (shell_title) : competitor_title,
          title: isShell ? (shell_title) : competitor_title,
          titleClass: station.brand.name.toLowerCase()
        });
        _self.setBocaActive();
      });
    }

    setSectionActive(section) {
      this.setState({ 
        isLoading: false,
        isCountry: section === 'country',
        isCluster: section === 'cluster',
        isBoca: section === 'boca',
        isEdit: section === 'edit',
        isStation: section === 'station',
      });
    }

    setCountryActive() {
      this.setState({ 
        titleClass: '',
        title: 'ARGENTINA'
      });
      this.setSectionActive('country');
    }

    setClusterActive() {
      this.setState({ 
        titleClass: '',
        title: 'ARGENTINA' + (this.state.clusterValue.label ? ('> ' + this.state.clusterValue.label) : '')
      });
      this.setSectionActive('cluster');
    }

    setBocaActive() {
      this.setSectionActive('boca');
    }

    setEditActive() {
      this.setSectionActive('edit');
      window.history.pushState('cluster', 'ARGENTINA > ' + this.state.clusterData.name, '/analisis/cluster/editar/' + this.state.clusterData.id);
    }

    setStationActive() {
      this.setSectionActive('station');
    }

    goToStation(station) {
      let isShell = station.brand.name.toLowerCase().indexOf('shell') >= 0;
      if (isShell) {
        this.setState({
          isBoca: false
        }, function() {
          this.getBocaItem(station);
        });
      } else {
        window.history.pushState('cluster', 'ARGENTINA > ' + station.inscription_number, '/analisis/estacion/' + station.id);
        let shell_title = ('Shell - Global code: ' + station.global_code + " (NI: " + station.inscription_number + ")");
        let competitor_title = station.brand.name + " " + station.inscription_number;
        this.setState({
          bocaValue: station,
          station: station,
          breadcrumbText: isShell ? shell_title : competitor_title,
          title: isShell ? shell_title : competitor_title,
          titleClass: station.brand.name.toLowerCase()
        }, function() {
          this.setStationActive();
        });
      }
    }

    render(){
        return (
            <div>
                <Header history={this.props.history} />
                <section className="dashboard">
                    <div className="container-fluid">
                      {(this.state.isLoading || this.state.isCountry || this.state.isCluster) && <div className="row">
                        <div className="col s12">
                          <div className="row">
                            <div className="col s3 no-gutter">
                              <Dropdown ref="dcountry" selected={this.state.searchValue} text='BUSCAR POR:&nbsp;&nbsp;&nbsp;' items={this.state.search} getItem={this.getSearchItem} />
                            </div>
                            <div className="col s2 no-gutter">
                              <Dropdown ref="dcluster" selected={this.state.clusterValue} text='' items={this.state.cluster} getItem={this.getClusterItem} />
                            </div>
                            <div className="col s2 no-gutter">
                              <Dropdown forceActive readOnly={this.state.readOnly} ref="dpump" autocomplete={this.autocompleteStation} text='' items={this.state.boca} getItem={this.getBocaItem} />
                            </div>
                            <div className="col s5 no-gutter">
                                
                            </div>
                          </div>
                        </div>
                      </div>}
                      {!this.state.isLoading && (this.state.isEdit || this.state.isStation || this.state.isBoca) && <div className="col s12">
                        <div className="row">
                          <div className="col s12 no-gutter">
                            <div className="breadcrumb">
                              <img onClick={this.goBack} alt="" src="/static/imgs/angle-right.svg" />
                              <span onClick={this.goBack}>Atras</span>
                              <div>|</div>
                              <b>{this.state.breadcrumbText}</b>
                            </div>
                          </div>
                        </div>
                      </div>}
                      <Title text={this.state.title} className={this.state.titleClass} />
                      {!this.state.isLoading && this.state.isCountry ? <MarketShare /> : ''}
                      {/*{!this.state.isLoading && this.state.isCountry ? <Strategy /> : ''}*/}
                      {!this.state.isLoading && this.state.isCluster ? <Pumps user={this.props.user} hasIcon={this.state.searchValue.id !== 'PROVINCE'} ref="pumps" data={this.state.clusterData} showStation={this.goToStation} showBoca={this.getBocaItem} click={this.setEditActive} /> : ''}
                      {!this.state.isLoading && this.state.isCluster ? <Prices level={this.state.searchValue.id} id={this.state.clusterData.id} /> : ''}
                      {/*{!this.state.isLoading && this.state.isCluster && this.state.searchValue.id === 'CLUSTER' ? <EditableStrategy level={this.state.searchValue.id} data={this.state.clusterData} /> : ''}*/}
                      {!this.state.isLoading && this.state.isCluster ? <Sensibility level={this.state.searchValue.id} data={this.state.clusterData} /> : ''}
                      {!this.state.isLoading && this.state.isCluster ? <MarketShareCluster id={this.state.clusterData.id} level={this.state.searchValue.id} /> : ''}
                      {!this.state.isLoading && this.state.isCluster ? <Desvios id={this.state.clusterData.id} level={this.state.searchValue.id} /> : ''}
                      {!this.state.isLoading && this.state.isEdit ? <Edit data={this.state.clusterData} save={this.saveEditCluster} cancel={this.cancelEditCluster} /> : ''}
                      {!this.state.isLoading && this.state.isBoca ? <CloseStations station={this.state.bocaValue} showStation={this.goToStation} cluster={this.state.clusterData} /> : ''}
                      {!this.state.isLoading && this.state.isBoca ? <PricesPump id={this.state.bocaValue.id} /> : ''}
                      {/*{!this.state.isLoading && this.state.isBoca ? <EditableStrategyPump data={this.state.bocaValue} /> : ''}*/}
                      {!this.state.isLoading && this.state.isBoca ? <Sensibility level={'STATION'} data={this.state.bocaValue} /> : ''}
                      {!this.state.isLoading && this.state.isBoca ? <Desvios id={this.state.bocaValue.id} level={'STATION'} /> : ''}
                      {!this.state.isLoading && this.state.isStation ? <Station station={this.state.bocaValue} cluster={this.state.clusterData} /> : ''}
                      {!this.state.isLoading && this.state.isStation ? <PricesStation id={this.state.station.id} /> : ''}
                    </div>
                </section>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Analisis);



// WEBPACK FOOTER //
// ./src/containers/analisis/analisis.js